<template>
  <div class="offer">

    <app-header
        :position="'fixed'"
        :top="'0px'"
        :background="'#2F1F4C'"
        @clickBack="clickBack"
        @clickMenu="clickMenu"
    />

    <div class="offer__title">
      Оферта
    </div>

    <div class="offer__wrapper">
      <div class="offer__descr">
        <b>Реквизиты компании:</b><br>
        ООО «Неваляшка»<br>
        ИНН 2312093100<br>
        КПП 231201001<br>
        Юридический адрес: 350911, г. Краснодар, ул. Трамвайная , 2 литер Г 152, оф. 11
      </div>

      <div class="offer__descr">
        <br><br>
        <b>1. Термины и определения</b><br><br>
        1.1. Сайт заказа поздравлений — веб-сайт https://www.52krd.ru  Это сервис,  предоставляющим доступ к информации о товарах,
        предназначенной для потенциальных Покупателей (потребителей).<br><br>
        1.2. Владелец сайта — ООО «Неваляшка» (Юридический адрес: ИНН 2312093100,
        Юридический адрес: 350911, г. Краснодар, ул. Трамвайная , 2 литер Г 152, оф. 11, тел.: 8 -918-464-27-27, e-mail: 52metrakrd@gmail.com).<br><br>
        1.3. Заказчик — любое физическое лицо, использующее Сайт  на условиях настоящего Пользовательского соглашения.<br><br>
        1.4. Заказ — осуществление Заказчиком действий, направленных на заключение им договора оказания услуг с Владельцем Сайта,
        посредством оформления заказа указанных услуг на Сайте.<br><br>
        1.5. Модерация – проверка текста поздравления, набранного Заказчиком на предмет соответствия требованиям к тексту,
        определенным данным Пользовательским соглашением.<br><br>
        1.6. Поздравление – цифровой материал, комплектуемый и создаваемый при помощи Сайта Заказчиком  и передаваемый на сетку
        Колеса обозрения 52 метра и включающий в себя элементы дизайна, выбранные Заказчиком, исходя из повода Поздравления,
        музыкальное оформление, а также текст Поздравления, прошедший впоследствии Модерацию.<br><br>
        1.7. Повод поздравления – категория, которую выбирает Заказчик до того, как перейти к выбору элементов дизайна, музыки
        и набору текста. У различных поводов поздравлений различная стартовая цена.<br><br>
        1.8. Услуги — отображение на светодиодной подсветке Колеса обозрения 52 метра, расположенного по адресу
        г. Краснодар ул. Постовая 34, парк «Городской сад»,  Поздравления, а также предоставление отснятого видеоматериала
        Поздравления с воздуха и/или с земли, при условии, что данная опция была также выбрана Заказчиком в процессе Заказа.
      </div>

      <div class="offer__descr" id="offer__descr-2">
        <br><br>
        <b>2. Правила заказа Поздравлений и условия прохождения Модерации</b><br>
        <br><em>Пользуясь Сайтом заказа поздравлений, Заказчик соглашается с условиями настоящих Правил заказа.</em>
        <br><br>2.1
        В процессе Модерации, Сайт заказа поздравлений вправе самостоятельно, с уведомлением Заказчика и
        <b>БЕЗ возврата денежных средств,  не допускать к отображению на светодиодной подсветке Колеса обозрения
          52 метра Заказы, составленные Заказчиком с нарушением данных правил.</b><br><br>
<!--        Текст Поздравления должен соответствовать следующим критериям: четкое соответствие текста-->
<!--        Поздравления выбранному Поводу.<br>-->
<!--        Повод Поздравления, выбранный Заказчиком должен соответствовать смысловой нагрузке текста, который-->
<!--        Заказчик набирает при составлении Поздравления. В случае, если  смысловая нагрузка теста поздравления-->
<!--        объединяет в себе два и более поводов, Заказчику необходимо выбрать повод, стартовая стоимость-->
<!--        Поздравлений в котором является наибольшей по цене.<br><br>-->

        2.1.1 Текст Поздравления должен соответствовать следующим критериям: <b>четкое соответствие смысла текста,
        который Заказчик вводит при составлении Поздравления, выбранному Поводу. Если смысл текста Поздравления
        подходит под два и более поводов, Заказчику необходимо выбрать более дорогой повод</b>, стартовая стоимость
        Поздравлений в котором является наибольшей по цене, <b>либо воспользоваться Полным каталогом в разделе
        выбора повода.</b><br><br>
        <b>2.1.2</b> В тексте Поздравления строго запрещается использование: <br>
        -  оскорбительных, унижающих человеческое достоинство, формирующих негативное отношение к какому-либо субъекту, порочащих слов и выражений;<br>
        - политических и религиозных лозунгов;<br>
        - призывов к насилию, жестокости и противоправным действиям;<br>
        - рекламы любого характера;<br>
        - номеров телефонов, контактов, адресов, сайтов, страниц в социальных сетях  и иной подобной информации;<br>
        - персональных данных;<br>
        - большого количества грубых ошибок и нарушений правил русского языка, сленга.<br><br>
        2.1.3 Текст поздравления может быть на русском языке.<br><br>
        <b>2.2. Модерация при наличии незначительных орфографических и пунктуационных ошибок.</b><br><br>
        2.2.1 В случае наличия в тексте очевидных орфографических и пунктуационных ошибок, модератор
        вправе вносить исправления и допускать Заказ к отображению на светодиодной подсветке Колеса
        обозрения 52 метра с внесенными изменениями, уведомив об этом Заказчика и <b>обязательно получив
        его согласие.  Опция возврата денежных средств в 100% объеме сохраняется в случае, если
        Заказчик отменил исправления Модератора, нажав кнопку Отмены на странице своего Заказа
        непосредственно в день модерации Заказа, но не позднее</b>. Если Заказчик нажал кнопку Отмены
        позднее дня Модерации Заказа, то возврат денежных средств осуществляется в соответствии
        с разделом 9. «Возврат денежных средств» настоящей Оферты.<br><br>
        2.2.2 <b>Если заказчик не подтвердил внесённые Модератором исправления, путем нажатия кнопки
        с Согласием на странице своего Заказа, то Заказ не отправляется на светодиодную подсветку
        Колеса, возврат денежных средств за такой Заказ не предусмотрен.</b>
      </div>

      <div class="offer__descr">
        <br><br>
        <b>3. Регистрация на Сайте заказа поздравлений</b><br><br>
        3.1. Оформить Заказ на Сайте заказа поздравлений  могут только зарегистрированные Заказчики.<br><br>
        3.2. Владелец сайта  не несет ответственности за точность и правильность информации,
        предоставляемой Заказчиком при регистрации.<br><br>
        3.3. Заказчик, зарегистрировавшийся на Сайте заказа поздравлений, получает индивидуальную
        идентификацию путем ввода смс с кодом доступа, направленного Владельцем сайта на указанный
        в Личном кабинете контактный номер. Индивидуальная идентификация Заказчика позволяет
        избежать несанкционированных действий третьих лиц от имени Заказчика и открывает доступ
        к дополнительным сервисам. Передача Заказчиком кода доступа третьим лицам запрещена.<br><br>
        3.4. Заказчик несёт ответственность за все возможные негативные последствия, в случае
        передачи кода доступа, а также учетных данных Личного кабинета третьим лицам.
      </div>

      <div class="offer__descr">
        <br><br>
          <b>4. Оформление заказа на Сайте заказа поздравлений</b><br><br>
          4.1. Оформляя Заказ на Сайте заказа поздравлений, Заказчик вступает в договорные отношения с Владельцем сайта  в рамках договора оказания Услуг.<br><br>
          4.2. Взаиморасчеты с Заказчиком за Услуги, заказанные им на Сайте заказа поздравлений, осуществляется Владельцем сайта от своего имени.<br><br>
          4.3. До момента совершения Заказа Заказчик обязуется ознакомиться со всеми условиями оказания Услуг Владельцем сайта.
      </div>

      <div class="offer__descr">
        <br><br>
          <b>5. Персональные данные и конфиденциальность</b><br><br>
          <em>Заказчик подтверждает свое согласие с тем, что:</em><br>
          5.1. Регистрационные данные (в том числе персональные данные) указаны им добровольно;<br><br>
          5.2. Регистрационные данные (в том числе персональные данные) передаются в электронной форме по открытым каналам связи сети «Интернет»;<br><br>
          5.3. Регистрационные данные (в том числе персональные данные) переданы Владельцу сайта для реализации целей,
            указанных в настоящем Пользовательском соглашении и в этих же целях могут быть переданы третьим лицам;<br><br>
          5.4. Регистрационные данные (в том числе персональные данные) могут быть использованы Владельцем сайта в
            целях продвижения товаров и услуг, путем осуществления прямых контактов с Заказчиком с помощью каналов связи;<br><br>
          5.5. Регистрационные данные (в том числе персональные данные) могут быть использованы Владельцем сайта в
            целях направления Заказчику  рекламы и информации по сетям электросвязи, в том числе через Интернет,
            в соответствии со ст.18 Ф3 «О рекламе» от 13.03.2006 г.;<br><br>
          5.6. В целях дополнительной защиты от мошеннических действий указанные Заказчиком регистрационные
            данные (в том числе персональные данные) могут быть переданы банку, осуществляющему транзакции по
            оплате оформленных на Сайте заказа поздравлений Заказов;<br><br>
          5.7. Данное Заказчиком согласие на обработку его регистрационных данных (в том числе персональных данных)
            является бессрочным и может быть отозвано Заказчиком  или его законным представителем, подачей
            письменного заявления, переданного Владельцу сайта.<br><br>
          <em>Владелец сайта обязуется:</em><br><br>
          5.8. Обрабатывать персональные данные Заказчика в порядке, установленном действующим
            законодательством и Правилами настоящего Пользовательского соглашения в отношении организации
            обработки и обеспечения безопасности персональных данных.<br><br>
          5.9. В случае отзыва Заказчика согласия на обработку его персональных данных Владелец сайта обязуется
            прекратить их обработку или обеспечить прекращение такой обработки (если обработка персональных
            данных осуществляется другим лицом, действующим по поручению Владельца сайта) и в случае, если
            сохранение персональных данных более не требуется для целей обработки персональных данных,
            уничтожить персональные данные или обеспечить их уничтожение (если обработка персональных данных
            осуществляется другим лицом, действующим по поручению Владельца сайта) в срок, не превышающий тридцати дней с
            даты поступления указанного отзыва, если иное не предусмотрено договором, стороной которого,
            выгодоприобретателем или поручителем по которому является Заказчик.
      </div>

      <div class="offer__descr">
        <br><br>
          <b>6. Действия Заказчика на Сайте заказа поздравлений </b><br><br>
          <em>Осуществляя Заказ, Заказчик подтверждает, что:</em><br>
          6.1. Полностью ознакомился с положениями настоящего Пользовательского соглашения;<br><br>
          6.2. Полностью понимает условия настоящего Пользовательского соглашения, а также предмет и условия заключаемого с
            Владельцем сайта договора на оказание Услуг.<br><br>
          6.3. Полностью понимает значение и последствия своих действий в отношении заключения и исполнения заключенного с
            Владельцем сайта договора на оказание Услуг посредством Сайта заказа поздравлений.<br><br>
          6.4. Оформляя заказ на Сайте заказа поздравлений, Заказчик соглашается на получение: (а) сообщений (SMS) на
            телефонный номер, указанный Заказчиком, а также (в) звонка с предложением оценить качество работы Сайта
            заказа поздравлений  на телефонный номер, указанный Заказчиком.<br><br>
          6.5. Владелец сайта  вправе заблокировать для Заказчика возможность осуществления Заказа в случае
            неоднократной отмены осуществленных Заказчиком Заказов, а также в случае нарушения
            Заказчиком условия настоящего Пользовательского соглашения.
      </div>

      <div class="offer__descr">
        <br><br>
          <b>7. Цена и оплата</b><br><br>
          7.1. Неотъемлемым условием оформления Заказа на Сайте заказа поздравлений  является заключение Заказчиком с
            Владельцем сайта  договора на оказание Услуг, посредством выбора опции «Согласен» в соответствующем окне.<br><br>
          7.2. Цены на Услуги определяются Владельцем сайта, в одностороннем бесспорном порядке и
            указываются на Сайте заказа поздравлений.<br><br>
          7.3. Заказчику, оформляющему Заказ на Сайте заказа поздравлений, предоставляется возможность
            выбрать вариант оплаты в соответствии с предусмотренными способами.<br><br>
          7.4. В соответствии с условиями настоящего  Пользовательского соглашения чек
            в электронной форме направляется Заказчику по смс.
      </div>

      <div class="offer__descr">
          <br><br>
          <em><b>Внимание!</b> Для оплаты (ввода реквизитов Вашей карты) Вы будете перенаправлены на платежный шлюз ПАО СБЕРБАНК.
            Соединение с платежным шлюзом и передача информации осуществляется в защищенном режиме с использованием протокола
            шифрования SSL. В случае если Ваш банк поддерживает технологию безопасного проведения интернет-платежей Verified By Visa
            или MasterCard SecureCode для проведения платежа также может потребоваться ввод специального пароля. Настоящий сайт
            поддерживает 256-битное шифрование. Конфиденциальность сообщаемой персональной информации обеспечивается ПАО СБЕРБАНК.
            Введенная информация не будет предоставлена третьим лицам за исключением случаев, предусмотренных законодательством РФ.
            Проведение платежей по банковским картам осуществляется в строгом соответствии с требованиями платежных систем МИР,
            Visa Int. и MasterCard Europe Sprl.</em>
      </div>

      <div class="offer__descr">
        <br><br>
          <b>8. Права и обязанности сторон</b><br><br>
          8.1 Владелец сайта имеет право:<br><br>
          8.1.1. Изменять настоящие Правила в одностороннем порядке, помещая их на Торговой площадке, расположенного по
              интернет-адресу: https://www.52krd.ru. Все изменения вступают в силу немедленно после публикации, и
              считаются доведенными до сведения Заказчика с момента такой публикации.<br><br>
          8.1.2. Без согласования с Заказчиком передавать свои права и обязанности по исполнению обязательств перед
              Заказчиком третьим лицам.<br><br>
          8.1.3. Потребовать от Заказчика 100% предоплаты за оказываемую услугу. Владелец сайта имеет право отказать
              Заказчику в оформлении Заказа при отсутствии такой оплаты.<br><br>
          8.1.4. Отменить Заказ с безналичным способом оплаты по истечении 10 минут с момента оформления, в
              случае не поступления оплаты.<br><br>
          8.1.5. Использовать технологию «cookies». «Cookies» не содержат конфиденциальную информацию и не передаются третьим лицам.<br><br>
          8.1.6. Получать информацию об ip-адресе посетителя веб-сайта www.52krd.ru. Данная информация не используется для установления
              личности посетителя и не подлежит передаче третьим лицам.<br><br>
          8.1.6. Направлять Покупателю сообщения рекламно-информационного характера посредством sms-рассылок с информацией о
              скидках, акциях и т.п. Частота рассылок определяется Владельцем сайта самостоятельно, в одностороннем порядке.<br><br>
          8.1.7. Отзыв настоящих условий может быть осуществлён Владельцем сайта в любое время, но это не
              является основанием для отказа от обязательств Владельца сайта. <br><br>
          8.2. Заказчик обязуется:<br><br>
          8.2.1. До момента заключения Договора ознакомиться с содержанием и условиями настоящего соглашения,
              ценами на Услуги, предлагаемыми на сайте, а также с порядком и условиями оказания Владельцем сайта услуг.<br><br>
          8.2.2. Оплатить Заказ в соответствии с настоящими условиями.<br><br>
          8.2.3. Не заказывать Услуги в предпринимательских целях.<br><br>
          8.2.4. Самостоятельно отслеживать погодные условия удобным ему способом и, в
            случае обнаружения ухудшения погодных условий на дату Заказа, своевременно и самостоятельно отменять Заказ.
            В случае бездействия Заказчика, денежные средства за оплаченный Заказ могут быть возвращены не в
            полном объеме и не возвращены совсем.<br><br>
          8.3. Заказчик имеет право:<br><br>
          8.3.1. Заказчик вправе отказаться от получения sms-рассылок, для этого ему нужно написать на
            электронную почту Владельца сайта, указанную в разделе сайта «контакты».
      </div>

      <div class="offer__descr">
        <br><br>
          <b>9. Возврат денежных средств</b><br><br>
          9.1. Возврат денежных средств в 100% объеме осуществляется в следующих случаях:<br><br>
          9.1.1. Заказчик отменил свой Заказ за 7 или более суток до выбранного им времени и даты при оформлении Заказа.<br><br>
          9.1.2. Заказчик не согласен с внесенными корректировками орфографических ошибок в соответствии с пунктом 2.2.1<br><br>
          9.2. Возврат денежных средств в размере 50% от стоимости Заказа возможен в следующих случаях:<br><br>
          9.2.1. Заказчик отменил свой Заказ в период от 7 до 3 суток до выбранного им даты и времени.<br><br>
          9.3. Возврат денежных средств не осуществляется в следующих случаях:<br><br>
          9.3.1. Заказчик нарушил  пункты 2.1.1 и 2.1.2 при составлении Заказа.<br><br>
          9.3.1. Заказчик отменил Заказ менее, чем за 3 суток от выбранного им времени и даты.<br><br>
          9.4. Все претензии по услугам, Заказчики должны направлять по адресу электронной почты,
            указанной в разделе «контакты» сайта.  В случае направления претензии по электронной почте,
            Заказчик  дает согласие на получение ответа на такую претензию также в электронном виде.
      </div>

      <div class="offer__descr">
        <br><br>
          <b>10. Форс-мажор</b><br><br>
          10.1. Владелец сайта освобождается от ответственности за полное или частичное неисполнение своих обязательств в
            соответствии с настоящими условиями, если это неисполнение было вызвано обстоятельствами непреодолимой силы,
            возникшими после принятия Заказчиком условий настоящего соглашения. «Обстоятельства Непреодолимой Силы»,
            означают чрезвычайные события или обстоятельства, которые нельзя было предвидеть или предотвратить доступными
            средствами. Такие чрезвычайные события или обстоятельства включают в себя, в частности: забастовки, наводнения,
            пожары, землетрясения и иные стихийные бедствия, войны, военные действия, действия российских или иностранных
            государственных органов, а также любые иные обстоятельства, выходящие за пределы разумного контроля.
      </div>
    </div>


    <transition
        name="fade-menu"
        appear
        mode="out-in"
    >
      <app-menu
          v-if="menu"
          idLogoMenu="header-component__menu"
          @clickLink="clickLink"
          @clickOutside="clickLink"
      />
    </transition>

    <transition
        name="fade-overlay"
        appear
        mode="out-in"
    >
      <app-overlay
          v-if="overlay"
      />
    </transition>

  </div>
</template>

<script>

const AppHeader = () => import('~/components/header.vue')
const AppMenu = () => import('~/components/menu.vue')
const AppOverlay = () => import('~/components/overlay.vue')

export default {
  async mounted() {
    let checkScroll = () => {
      if(document.readyState === 'complete') {
        if(this.$route.query.id) {

          let el = document.getElementById(`offer__descr-${this.$route.query.id}`)

          let scrollToElement = (theElement)  => {
            let selectedPosX = 0;
            let selectedPosY = 0;
            while (theElement != null) {
              selectedPosX += theElement.offsetLeft;
              selectedPosY += theElement.offsetTop;
              theElement = theElement.offsetParent;
            }
            window.scrollTo(selectedPosX,selectedPosY);
          }

          scrollToElement(el)

        }
      } else {
        setTimeout(() => {
          checkScroll()
        }, 100)
      }
    }
    checkScroll()


  },
  data() {
    return {
      menu: false,
      overlay: false
    }
  },
  methods: {
    async clickBack() {
      this.$router.back()
    },
    async clickMenu() {
      this.overlay = true
      this.menu = true
    },
    async clickLink() {
      this.menu = false
      this.overlay = false
    }
  },
  components: {
    AppHeader,
    AppMenu,
    AppOverlay
  }
}
</script>

<style lang="less">

@import '~/assets/fonts/montserrat/Montserrat-Bold.less';

.offer {
  background-color: #2F1F4C;
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 20px;
  user-select: text;
}

.offer__title {
  font-size: 20px;
  line-height: 20px;
  font-family: 'Montserrat-Bold';
  color: #FFFFFF;
  text-align: center;
  margin-top: 64px;
  margin-bottom: 32px;
  width: 100%;
  padding: 0px 20px;
  font-size: 20px;
}

.offer__wrapper {
  display: flex;
  width: 100%;
  flex-direction: column;
  max-width: 1000px;

}

@import '~/assets/fonts/montserrat/Montserrat-Light.less';

.offer__descr {
  font-size: 16px;
  font-family: 'Montserrat-Light';
  padding: 0px 30px;
  color: #FFFFFF;
  line-height: 22px;
  margin-bottom: 20px;
}

.offer__descr a {
  color: #00bcd4;
  cursor: pointer;
  text-decoration: none;
}
</style>